import { render, staticRenderFns } from "./StoreRegistration.vue?vue&type=template&id=622cbd0c&scoped=true&"
import script from "./StoreRegistration.vue?vue&type=script&lang=js&"
export * from "./StoreRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622cbd0c",
  null
  
)

export default component.exports